import type { ItemStatus } from './inventory';

/**
 * A country's asset register (tidaltech/issues#9521): every item at its
 * sites, one entry per serial, such as the monthly register for HEAV ADM in
 * Chile. Leatherback works out each item's condition, so the download and
 * the monthly job agree.
 */
export const registerConditions = [
  'CONDITION_UNSPECIFIED',
  'OPERATIONAL',
  'NEEDS_REPAIR',
  'NEEDS_CHECK',
] as const;
export type RegisterCondition = (typeof registerConditions)[number];

export const registerConditionLabels: Record<RegisterCondition, string> = {
  CONDITION_UNSPECIFIED: '',
  // In service at a site, or fit to deploy.
  OPERATIONAL: 'Operational',
  // Diagnosed as broken, or scrapped.
  NEEDS_REPAIR: 'Needs repair',
  // New, returned, replaced or flagged: to be checked before deployment.
  NEEDS_CHECK: 'Needs check',
};

export interface ItemRegisterEntry {
  itemId: string;
  partId?: string | undefined;
  partType?: string | undefined;
  build?: string | undefined;
  status?: ItemStatus | undefined;
  /** For an item in transit, the condition it had before it left. */
  condition?: RegisterCondition | undefined;
  inTransit?: boolean | undefined;
  siteId?: string | undefined;
  siteName?: string | undefined;
  customerId?: string | undefined;
  customerName?: string | undefined;
  /** One of Tidal's own sites, such as a warehouse. */
  tidalSite?: boolean | undefined;
  /** The pen or other place at the site. */
  location?: string | undefined;
  installationDate?: string | undefined;
}

export interface ItemRegister {
  entries: ItemRegisterEntry[];
  readAt?: string | undefined;
}
